import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';

const columns = [
    {
        dataField: 'options',
        text: 'Options',
        sort: false,
        width: 70,
        show: true,
        hidecolFilter: true,
        action: true
    },
    {
        dataField: 'poid',
        text: 'POID',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.poid),
    },
    {
        dataField: 'poStatus',
        text: 'PO Status',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.poStatus),
    },
    {
        dataField: 'poItemStatus',
        text: 'Item Status',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.poItemStatus),
    },
    {
        dataField: 'createdDate',
        text: 'Creaded Date ',
        sort: false,
        width: 140,
        show: true,
        inputType: 'date',
        hideColFilter: true,
        cellRenderer: (rowData) => dateFormate(rowData.createdDate),
    },
    {
        dataField: 'packageOrdered',
        text: 'Ordered Pkgs',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData) => cellRendererCheck(rowData.packageOrdered),
    },
    {
        dataField: 'packageInvoiced',
        text: 'Processed Pkgs',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData) => cellRendererCheck(rowData.packageInvoiced),
    },
    {
        dataField: 'reconciledPkgs',
        text: 'Reconciled Pkgs',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.reconciledPkgs),
    },
    
];

const UnitsReplenishedTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='inventory-table'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            hasScrollArrow={false}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            hasPagination
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            filters={colFilter}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default UnitsReplenishedTable;
